module.exports = globalThis["ReactDOM"];